import { createAction, props } from '@ngrx/store';

import { Quote, UserLite } from '@lockton-apps/shared/interfaces';

export enum ClientEnquiriesActionTypes {
  Init = '[ClientEnquiries Page] Init',
  BrokerAssigned = '[ClientEnquiries Page] Broker Assigned',
  SendRenewalInvite = '[ClientEnquiries Page] Send Renewal Invite',
  UpdateProposalType = '[ClientEnquiries Page] Update Proposal Type',
  ProposalReturned = '[ClientEnquiries Page] Proposal Returned',
}

export const ClientEnquiriesActions = {
  init: createAction(ClientEnquiriesActionTypes.Init),
  brokerAssigned: createAction(
    ClientEnquiriesActionTypes.BrokerAssigned,
    props<{ quoteId: number; user: UserLite | null }>()
  ),
  sendRenewalInvite: createAction(
    ClientEnquiriesActionTypes.SendRenewalInvite,
    props<{ quote: Quote }>()
  ),
  updateProposalType: createAction(
    ClientEnquiriesActionTypes.UpdateProposalType,
    props<{ quote: Quote; subType: number }>()
  ),
  proposalReturned: createAction(
    ClientEnquiriesActionTypes.ProposalReturned,
    props<{ quote: Quote }>()
  ),
};
